//gpt: es6 format date to thai date, with format dd-MMM-yyyy
export const formatDateTH = (dt) => {
  try {
    // const date = new Date('2023-03-12');
    const date = new Date(dt);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric', // เปลี่ยนจาก '2-digit' เป็น 'numeric' เพื่อไม่ให้มี leading zero
      timeZone: 'UTC',
    };

    //   const thaiMonthNames = new Intl.DateTimeFormat('th-TH', {
    //     month: 'long',
    //   }).formatToParts();

    //   const monthMap = new Map(
    //     thaiMonthNames
    //       .filter(({ type }) => type === 'month')
    //       .map(({ value }) => [value, value])
    //   );

    const thaiDate = date.toLocaleDateString('th-TH', options);
    // .replace(/\//g, '-')
    // .replace(/(\w{3})/, (match, p1) => monthMap.get(p1));

    return thaiDate;
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const formatDateTHDMMMYYYY = (dt) => {
  try {
    // const date = new Date('2023-03-12');
    const date = new Date(dt);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric', // เปลี่ยนจาก '2-digit' เป็น 'numeric' เพื่อไม่ให้มี leading zero
      timeZone: 'UTC',
    };

    //   const thaiMonthNames = new Intl.DateTimeFormat('th-TH', {
    //     month: 'long',
    //   }).formatToParts();

    //   const monthMap = new Map(
    //     thaiMonthNames
    //       .filter(({ type }) => type === 'month')
    //       .map(({ value }) => [value, value])
    //   );

    const thaiDate = date.toLocaleDateString('th-TH', options);
    // .replace(/\//g, '-')
    // .replace(/(\w{3})/, (match, p1) => monthMap.get(p1));

    return thaiDate;
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const formatDateTHYYYYMMDD = (dt) => {
  try {
    if (!dt) return '';
    
    const date = new Date(dt);
    
    // ใช้ UTC methods เพื่อหลีกเลี่ยงปัญหา timezone
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
    const day = String(date.getUTCDate()).padStart(2, '0');
    
    // return ในรูปแบบ yyyymmdd
    return `${year}${month}${day}`;
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const formatDateYYYYMMDD = (dt) => {
  try {
    if (!dt) return '';
    
    const date = new Date(dt);
    
    // ใช้ th-TH locale แต่บังคับให้ใช้ปฏิทิน Gregorian (ค.ศ.)
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      calendar: 'gregory', // บังคับใช้ปฏิทิน Gregorian
    };
    
    const formatter = new Intl.DateTimeFormat('th-TH-u-ca-gregory', options);
    const parts = formatter.formatToParts(date);
    
    // สร้างรูปแบบ yyyy-mm-dd จาก parts
    const year = parts.find(p => p.type === 'year').value;
    const month = parts.find(p => p.type === 'month').value;
    const day = parts.find(p => p.type === 'day').value;
    
    return `${year}-${month}-${day}`; // yyyy-mm-dd
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const formatTHMMM = (dt) => {
  try {
    const date = new Date(dt); // Replace with your desired date

    // month: 'short',
    const options = {
      month: 'long',
      timeZone: 'Asia/Bangkok',
    };

    const thaiMonth = date.toLocaleDateString('th-TH', options);
    // console.log(thaiMonth);
    return thaiMonth;
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const formatDateTHYYYY = (dt) => {
  try {
    const date = new Date(dt); // create a new Date object with the current date and time
    const thaiLocale = 'th-TH-u-ca-buddhist'; // specify the Thai language and Buddhist calendar
    const options = { year: 'numeric' }; // specify the year format option
    const buddhistYear = new Intl.DateTimeFormat(thaiLocale, options).format(
      date
    ); // format the date using the Thai locale and options
    console.log(buddhistYear); // output the Buddhist year

    const thYear = buddhistYear.substring(buddhistYear.lastIndexOf(' ') + 1);

    return thYear;
  } catch (err) {
    console.log(err);
    return '';
  }
};

// import moment from 'moment'

// export const dateDiff = (from, to) => {
//   const fromMoment = moment(from)
//   const toMoment = moment(to)

//   const years = fromMoment.diff(toMoment, 'year')
//   toMoment.add(years, 'years')

//   const months = fromMoment.diff(toMoment, 'months')
//   toMoment.add(months, 'months')

//   const days = fromMoment.diff(toMoment, 'days') + 1

//   return {
//     years,
//     months,
//     days
//   }
// }

// export const getYear = (date) => {
//   const year = moment(date).year()
//   return year
// }

// export const getDisplayDate = (date, isTime) => {
//   if (!date) {
//     return '-'
//   }
//   const showDate = moment(date)
//   if (isTime) {
//     return showDate.format(`dd DD / MM / ${showDate.year() + 543} เวลา HH:mmน.`)
//   }
//   return showDate.format(`dd DD / MM / ${showDate.year() + 543}`)
// }
